import { Notifications } from 'library/constants'

export default function stakeChecker(
  stake: string,
  maxBet: number,
  minBet: number,
  balance: string,
  handleNotification: any
) {
  const n = +stake
  if (n > maxBet) {
    return handleNotification(Notifications.maxStake + stake)
  }
  if (n < minBet) {
    return handleNotification(Notifications.minStake + stake)
  }
  if (n > +balance) {
    return handleNotification(Notifications.notEnoughBalance)
  }
  return true
}
